import { MaterialLayoutRenderer } from '@jsonforms/material-renderers';
import { rankWith, uiTypeIs } from '@jsonforms/core';
import React from 'react';
import { withJsonFormsLayoutProps } from '@jsonforms/react';

import { useResponsive } from '../../../services/hooks';

const HorizontalResponsiveRenderer = props => {
  const isDesktop = useResponsive('up', 'lg');
  const { uischema, schema, path, visible, renderers } = props;

  const layoutProps = {
    elements: uischema.elements,
    schema,
    path,
    direction: isDesktop ? 'row' : 'column',
    visible,
    uischema,
    renderers
  };

  return (
    <MaterialLayoutRenderer {...layoutProps} />
  );
};

export default withJsonFormsLayoutProps(HorizontalResponsiveRenderer);

export const HorizontalResponsiveTester = rankWith(1000, uiTypeIs('HorizontalResponsive'));
